import { InterviewFeedback } from '../interviewFeedback';


export class FeedbackSerializer {
    fromJson(json: any): InterviewFeedback {
    
        const data = new InterviewFeedback();
        data.interviewId = json.interviewId;
        data.interviewStepMappingId =json.interviewStepMappingId;
        data.feedback= json.feedback;
        data.interviewStatus= json.InterviewStatus;
        data.interviewStepStatus= json.interviewStepStatus;
        return data;
    }

    toJson(data: InterviewFeedback): any {
        return {
            id: data.id,
            interviewId: data.interviewId,
            interviewStepMappingId: data.interviewStepMappingId,
            feedback: data.feedback,
            interviewStatus :data.interviewStatus,
            interviewStepStatus :data.interviewStepStatus
        };
    }
}